var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerify1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Verify",
    clipPath: "url(#clip0_4046_16355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 31.1996C7.3 31.1996 0.2 24.1996 0 15.5996C0 15.6996 0 15.7996 0 15.9996C0 24.7996 7.2 31.9996 16 31.9996C24.8 31.9996 32 24.7996 32 15.9996C32 15.8996 32 15.7996 32 15.5996C31.8 24.2996 24.7 31.1996 16 31.1996Z",
    fill: "#CCE0DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.0996 10.3996L24.5996 9.89961C24.3996 9.69961 24.1996 9.59961 23.9996 9.59961C23.7996 9.59961 23.4996 9.69961 23.3996 9.89961L14.6996 18.5996L9.99961 13.9996C9.69961 13.6996 9.09961 13.6996 8.69961 13.9996L8.19961 14.4996C7.89961 14.7996 7.89961 15.3996 8.19961 15.6996L13.6996 21.1996C13.8996 21.3996 14.2996 21.5996 14.5996 21.5996C14.8996 21.5996 15.2996 21.4996 15.4996 21.1996L25.0996 11.5996C25.2996 11.3996 25.3996 11.1996 25.3996 10.9996C25.3996 10.7996 25.2996 10.5996 25.0996 10.3996Z",
    fill: "#1CD299"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4046_16355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify1);
export default __webpack_public_path__ + "static/media/Verify (1).3ab07fcc771fff5a5a95742c893afde9.svg";
export { ForwardRef as ReactComponent };